module.exports = __webpack_public_path__ + "static/media/horse-playing-football1.a331be3a.gif";